import * as z from "zod";
import { cursorPageOf, cursorPagination } from "../index";
import { notificationChannels, notificationStatuses } from "./enums";

// What was sent, to whom and about what (`platform.notification`, FR-M14-05, ADR-149 point 9): the log of every
// email, and the history of one entity with the same list. The values an email was written with stay in the DB.

/** The latest written first. */
export const listNotificationsInput = z.object({
  status: z.enum(notificationStatuses).optional(),
  templateCode: z.string().trim().min(1).max(80).optional(),
  /** Schema-qualified, e.g. `catalog.linesheet_invitation`: with `entityId`, the history of one entity. */
  entityType: z.string().trim().min(1).max(80).optional(),
  entityId: z.uuid().optional(),
  ...cursorPagination({ defaultLimit: 50, maxLimit: 200 }),
});
export type ListNotificationsInput = z.input<typeof listNotificationsInput>;

export const notificationDto = z
  .object({
    id: z.uuid(),
    templateCode: z.string(),
    channel: z.enum(notificationChannels),
    /** Null for the one row of an event nobody could be written about. */
    recipientEmail: z.string().nullable(),
    recipientName: z.string().nullable(),
    /** The mailbox it really went to, when the environment sends elsewhere (P-02 of the UAT, ADR-297); null, the recipient. */
    deliveredTo: z.string().nullable(),
    /** As written when the email left; null before. */
    subject: z.string().nullable(),
    entityType: z.string().nullable(),
    entityId: z.uuid().nullable(),
    status: z.enum(notificationStatuses),
    /** Why it did not leave, or why it was suppressed. */
    error: z.string().nullable(),
    createdAt: z.iso.datetime(),
    sentAt: z.iso.datetime().nullable(),
  })
  .meta({ id: "Notification" });

export const notificationPageDto = cursorPageOf(notificationDto).meta({ id: "NotificationPage" });
